// extracted by mini-css-extract-plugin
export default {"ctn":"mainPoint_ctn__SXNdr","textBox":"mainPoint_textBox__2JZS6","testBox":"mainPoint_testBox__qXDQb"};